// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Cmd4A","noInteraction":"EventWrapper_noInteraction__2rc93"};